import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'mwo-item-selector',
  templateUrl: './item-selector.component.html',
  styleUrls: ['./item-selector.component.scss']
})
export class ItemSelectorComponent implements OnInit {
  @Input() itemsType: string;
  @Input() itemList: Array<{ id: string, name: string }>;
  @Input() search: string;
  @Output() itemSelected = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit() {
  }
}
